import { Checkbox } from "@material-ui/core"

const NCCheckbox = props => {
  return <Checkbox {...props} />
}

export default NCCheckbox
